import styled, { keyframes } from "styled-components";
import { Small } from "../../settings/layout";
import { Colors } from "../../settings/colors";

const iconAnimations = keyframes`
    50% {
        transform: scale(1.1);
    }
`;

export const ExpenseIcon = styled.div`
    border-radius: 100%;
    background-color: #33a7e2;
    color: #fff;
    position: relative;
    overflow: hidden;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    transition: scale 0.2s ease;

    svg {
        color: #fff;
        width: 16px;
        height: 16px;
        /* position: absolute; */
        top: 0;
        bottom: 0;
        left: 0;
        border: 0;
    }

    ::before {
        display: block;
        content: "";
        padding-top: 100%;
    }
`;

export const ExpenseContainer = styled.div`
    display: flex;
    margin-bottom: 20px;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease, border-radius 0.2s ease;

    :hover {
        background: ${Colors.LightText};
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        cursor: pointer;

        ${ExpenseIcon} {
            animation: ${iconAnimations} 0.3s ease;
        }
    }
`;

export const ExpenseContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const ExpenseHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 5px;
`;

export const ExpenseCategory = styled.p`
    flex: 1;
`;

export const ExpenseAmount = styled.div`
    display: flex;
    align-items: center;

    ${Small} {
        margin-right: 2px;
    }
`;
